import { useTranslation } from "@redotech/redo-i18n";
import type { Auth } from "@redotech/redo-merchant-app-common/auth";
import {
  type NotificationBannerItem,
  RedoNotificationBanner,
} from "@redotech/redo-web/arbiter-components/notification/redo-notification-banner";
import { memo } from "react";
import { autoOnboardingUrl } from "../../../onboarding";
import type { ReturnsOnboardingResumeState } from "../../../onboarding/returns-onboarding-resume-state";

export interface ReturnsOnboardingResumeBannerProps {
  auth: Pick<Auth, "teamId" | "token">;
  onDismiss?: () => void;
  state: NonNullable<ReturnsOnboardingResumeState>;
  teamId: string;
}

export const ReturnsOnboardingResumeBanner = memo(
  function ReturnsOnboardingResumeBanner({
    auth,
    onDismiss,
    state,
    teamId,
  }: ReturnsOnboardingResumeBannerProps) {
    const { t, i18n } = useTranslation();
    const url = autoOnboardingUrl(
      auth.token,
      auth.teamId,
      "resume-banner",
      i18n.language,
    ).toString();
    const items: NotificationBannerItem[] = [
      {
        id: `returns-onboarding-resume-banner:${teamId}`,
        message: t(
          "Finish Returns setup — {{completedSteps}} of {{totalSteps}} done",
          {
            completedSteps: state.completedSteps,
            totalSteps: state.totalSteps,
          },
        ),
        type: "info",
        actions: [
          {
            actionType: "link",
            href: url,
            internal: false,
            target: "_blank",
            text: t("Continue setup"),
          },
        ],
      },
    ];

    return <RedoNotificationBanner items={items} onDismiss={onDismiss} />;
  },
);
